module.exports = __webpack_public_path__ + "static/cover-dance-2ed1486033aad898c1aefa7752bfd2f6.mp4";